import React from 'react';
import Link from 'Components/Shared/Link/Link';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import { IMenu } from 'Components/MenuFooter/MenuFooter';

const HorizontalMenu: React.SFC<IMenu> = ({
  displayName, 
  formattedName,
  items,
}) => {
  return (
    <div className='horizontal-menu'>
      <FormattedText style='title' { ... { displayName, formattedName } } /> 
      { items.map(i => <Link style='item' key={ i.id } { ...i } />) }
    </div>
  );
};

export default HorizontalMenu;


// WEBPACK FOOTER //
// ./src/components/MenuFooter/SubMenues/HorizontalMenu.tsx